import axios from "./axiosExt";
import endpoints from "@config/endpoints";
import { decodeWithKeyAndShift, encodeWithKeyAndShift } from "./base64Utils";
const MAX_LOGS = 5; 

const logErrorToLocalStorage = (error:any) => {
   const errorLogs:any = JSON.parse(localStorage.getItem('test') ?? 'null');
    errorLogs?.push({
        error: error.message || error,  
        timestamp: new Date().toISOString() 
    });
    if (errorLogs?.length > MAX_LOGS) {
        errorLogs?.shift(); // Remove the first (oldest) error log
    }
    localStorage.setItem('errorLogs', JSON.stringify(errorLogs));
};

//define enum
export enum  LogType {
    Error = "error",
    Warning = "warning",
    Info = "info"
}

const getBrowserDetails = (module?:any) => {
    const loggerInUserId = localStorage?.getItem('userId');
    const loggedInUserDetails = localStorage?.getItem('userDetails');
    const decodedUserData=loggedInUserDetails?JSON.parse(decodeWithKeyAndShift(loggedInUserDetails)):null;
    const browserDetails = {
        userAgent: navigator.userAgent, // User agent string (e.g., browser, OS info)
        platform: navigator?.platform, // Platform (e.g., Windows, Mac, Linux)
        language: navigator.language, // Language of the browser (e.g., en-US)
        cookiesEnabled: navigator.cookieEnabled, // Whether cookies are enabled
        onlineStatus: navigator.onLine, // Whether the browser is online or offline
        module:module, //module of the logger,
        loggedInUserDBId:loggerInUserId ?? null, //logged in user db id
        loggedInUserMobileNumber:decodedUserData ? decodedUserData?.mob ?? null : null //logged in user mobile number
    };
    return browserDetails;
};
export async function appLogger(logType:any,data: any,module?:any) {
    const source= getBrowserDetails(module);
    const payload={
        loggerDetails:data,
        sourceDetails:source,
        typeOfLog:logType
    }
    const encodedPayload = encodeWithKeyAndShift(JSON.stringify(payload));
    try{
    const res = await axios.post(`${endpoints.applicationLogger}`,{data:encodedPayload});
    }
    catch(error:any){
        logErrorToLocalStorage(error);
    }
}
export async function errorLogger(data: any,module?:any) {
    await appLogger(LogType.Error,data,module);
}
export async function warningLogger(data: any,module?:any) {
    await appLogger(LogType.Warning,data,module); 
}
export async function infoLogger(data: any,module?:any) {
    await appLogger(LogType.Info,data,module);
}
